import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import { DeletedUserItem, GetDeletedUsersParams, PaginatedResponse, typicodeApi } from 'shared/api';

// Отдельный ключ, чтобы не пересекаться с кэшем активного списка ['users', params]
const DELETED_USERS_KEY = ['users', 'deleted'];

export const useDeletedUsers = (params: GetDeletedUsersParams) =>
  useQuery<AxiosResponse<PaginatedResponse<DeletedUserItem>>>(
    [...DELETED_USERS_KEY, params],
    () => typicodeApi.user.getDeletedUsers(params),
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
